<template>
  <div>404</div>
</template>

<script>
export default {
  name: 'error'
}
</script>

<style scoped>

</style>
